<template>
    <div class="interior-view__foot">
        <div class="interior-recommend">
            <h2 class="interior-recommend__title">추천 인테리어</h2>
            <div class="grid">
                <!-- 리스팅 -->
                <div class="grid-8">
                    <div role="link" class="interior-list">
                        <span class="interior-list__thumb">
                            <span class="interior-list__thumbnail">
                                <span class="interior-list__thumbnail-image" style="background-image: url('/images/sample/product-thumbnail-medium.jpg');"></span>
                            </span>
                            <span class="interior-list__thumb-image"></span>
                        </span>
                        <span class="interior-list__title">추천 인테리어 타이틀</span>
                        <ul class="interior-list__infos">
                            <li class="interior-list__info">아파트</li>
                            <li class="interior-list__info">46평대</li>
                            <li class="interior-list__info">17천만원대</li>
                        </ul>
                    </div>
                </div>
                <div class="grid-8">
                    <div role="link" class="interior-list">
                        <span class="interior-list__thumb">
                            <span class="interior-list__thumbnail">
                                <span class="interior-list__thumbnail-image" style="background-image: url('/images/sample/product-thumbnail-medium.jpg');"></span>
                            </span>
                            <span class="interior-list__thumb-image"></span>
                        </span>
                        <span class="interior-list__title">추천 인테리어 타이틀</span>
                        <ul class="interior-list__infos">
                            <li class="interior-list__info">아파트</li>
                            <li class="interior-list__info">46평대</li>
                            <li class="interior-list__info">17천만원대</li>
                        </ul>
                    </div>
                </div>
                <div class="grid-8">
                    <div role="link" class="interior-list">
                        <span class="interior-list__thumb">
                            <span class="interior-list__thumbnail">
                                <span class="interior-list__thumbnail-image" style="background-image: url('/images/sample/product-thumbnail-medium.jpg');"></span>
                            </span>
                            <span class="interior-list__thumb-image"></span>
                        </span>
                        <span class="interior-list__title">추천 인테리어 타이틀</span>
                        <ul class="interior-list__infos">
                            <li class="interior-list__info">아파트</li>
                            <li class="interior-list__info">46평대</li>
                            <li class="interior-list__info">17천만원대</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
